import SkapaInlineMessage, {
  type InlineMessageProps,
  type InlineMessageVariant,
} from "@ingka/inline-message";

const InlineMessage = (
  props: InlineMessageProps & React.HTMLAttributes<HTMLDivElement>
) => {
  return <SkapaInlineMessage prefix="saleslead__" {...props} />;
};

export { InlineMessage, type InlineMessageVariant };
